// Shared layout for the reserved areas (Fase 2 reference style):
// light background, big ZERAMI logo, blue title, grey subtitle, centered white card.
export const AreaShell = ({ title, subtitle, badge, children, testId, maxWidth = "max-w-[520px]" }) => (
  <main data-testid={testId} className="min-h-screen bg-zr-bg font-inter text-zr-blue">
    <div className="mx-auto flex min-h-screen w-full flex-col items-center px-4 py-12 sm:py-16">
      <a href="/" data-testid="area-logo" aria-label="ZERAMI">
        <img src="/logo-zerami.png" alt="ZERAMI" className="w-[200px] object-contain" />
      </a>
      {badge && (
        <span
          data-testid="area-badge"
          className="mt-6 inline-flex items-center gap-2 rounded-full bg-zr-light px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-zr-blue"
        >
          {badge}
        </span>
      )}
      <h1 data-testid="area-title" className="mt-5 text-center text-4xl font-bold tracking-tight text-zr-blue sm:text-5xl">
        {title}
      </h1>
      {subtitle && (
        <p data-testid="area-subtitle" className="mt-3 text-center text-base text-zr-grey md:text-lg">
          {subtitle}
        </p>
      )}
      <section
        data-testid="area-card"
        className={`mt-10 w-full ${maxWidth} rounded-2xl bg-white p-8 text-center shadow-[0_8px_30px_rgba(30,58,95,0.08)] sm:p-10`}
      >
        {children}
      </section>
    </div>
  </main>
);

export const GreenButton = ({ children, className = "", ...props }) => (
  <button
    className={`inline-flex items-center justify-center gap-2 rounded-xl bg-zr-green px-6 py-3 text-sm font-semibold text-white transition-colors duration-200 hover:bg-[#43A047] disabled:cursor-not-allowed disabled:opacity-60 ${className}`}
    {...props}
  >
    {children}
  </button>
);
